import HTTP from '@/plugins/axios';
import type { IAiExtractJobFiltersResponse, IAiExtractJobGroupFiltersResponse } from '@/types/aiTool';

export const extractJobFilters = async(params: { text: string, sid?: string }) => {
  const { sid, ...body } = params;
  const response = await HTTP.post('/ai_tool/extract_job_filters', body, { params: sid != null ? { sid } : {} });
  return response.data as IAiExtractJobFiltersResponse;
};

export const extractJobGroupFilters = async(params: { text: string, sid: string }) => {
  const { sid, ...body } = params;
  const response = await HTTP.post('/ai_tool/extract_job_group_filters', body, { params: { sid } });
  return response.data as IAiExtractJobGroupFiltersResponse;
};
